@if (!(isLoaded$ | async)) {
  <app-egg-spinner-overlay
  ></app-egg-spinner-overlay>
} @else {
  <section
    class="app-main"
    [ngClass]="{
      'billboard-visible-v2': (displayStickyBanner$ | async)
    }"
    >
    @if (displayMaintenanceBanner$ | async) {
      <div
        class="top-notification-banner maintenance-banner"
        role="banner"
        [innerHTML]="maintenanceMessageHtml"
      ></div>
    }
    <app-header-nav></app-header-nav>
    <main class="main-container app-containerv2--hub">
      <router-outlet></router-outlet>
    </main>
    <app-simplified-footer></app-simplified-footer>
  </section>
}

